<template>
    <svg viewBox="0 0 8 13" fill="none">
        <path d="M6 2L1.5 6.5L6 11" stroke="white" stroke-width="2.45455" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
